import angular from 'angular';
import booksMenu from '../../menu/Menu';
import CSMCommonWeb from 'csm-common-web';
import ngRoute from 'angular-route';
import booksDom from '../../booksDom';
import booksServices from '../../booksServices';
import returnItems from '../../com/returnItems/returnItems';
import nsfChecksConfig from './NSFChecksConfig';
/** Services */
import { NsfChecksServiceProvider } from './services/Services';
import { runCheckPaymentData } from './services/Data/CheckPayment';
import { runItemReversalData } from './services/Data/ItemReversal';
import { runNsfCheckData } from './services/Data/NSFCheck';
/** Dom */
import { findChecksDialogDirective } from './dom/findChecksDialog';
import { findNsfDialogDirective } from './dom/findNSFDialog';
import { FineLevyService, fineLevyComponent } from './dom/fineLevy';
import { nsfCheckComponent } from './dom/nsfCheck';
import './nsfChecks.scss';

export default angular
  .module('csm.books.NSFChecks', [
    nsfChecksConfig,
    booksMenu,
    CSMCommonWeb,
    ngRoute,
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.cellNav',
    booksDom,
    booksServices,
    returnItems
  ])
  .controller('NSFChecksController', Controller)
  .run(runInit)
  .provider('NSFChecksService', NsfChecksServiceProvider)
  .factory('Data', initDataFactory)
  .run(runCheckPaymentData)
  .run(runItemReversalData)
  .run(runNsfCheckData)
  .directive('findChecksDialog', findChecksDialogDirective)
  .directive('findNsfDialog', findNsfDialogDirective)
  .service('FineLevyService', FineLevyService)
  .component('fineLevy', fineLevyComponent)
  .component('nsfCheck', nsfCheckComponent).name;

initDataFactory.$inject = [];

/* @ngInject */ function initDataFactory() {
  return {};
}

/*******************************************************************************
 * Controller */
/**
 * @ngdoc   controller
 * @module  csm.books.nsf
 * @name    csm.books.nsf.controller:Controller
 * @description
 * Initializes the application by removing the busy screen.
 *******************************************************************************/
/* @ngInject */ function Controller($appFlags, $rootScope, BusyScreen) {
  BusyScreen.setBusy(false);
  $rootScope.appFlags = $appFlags;
}

/*******************************************************************************
 * @ngdoc   run
 * @module  csm.books.nsf
 * @name    csm.books.nsf.run:Init
 * @description
 * Add handler for route failing during resolve to redirect accordingly.
 *******************************************************************************/
/* @ngInject */ function runInit($rootScope, $location, NSFChecksConfig) {
  $rootScope.$on('$routeChangeError', function () {
    var rejectReason = arguments[3];

    /*---------------------------------------------------*/
    /* Redirect to the root for a root rejection request */
    /*---------------------------------------------------*/
    if (rejectReason == 'root') $location.url('/');
  });
}
